import React from 'react';
import styles from './school-statistics.module.css';

const SchoolStatistics = () => (
  <div>
    school-statistics Component
  </div>
);

export default SchoolStatistics;
